import React from 'react';
import JobInfoTag from '@components/ka-ui/job-info-tag/JobInfoTag';
import LocationIcon from '@assets/svgs/location-icon.svg';
import CalendarIcon from '@assets/svgs/calendar-icon.svg';
import UserTimeIcon from '@assets/svgs/user-time-icon.svg';
import PropTypes from 'prop-types';
import JobInfoTagTypeEnum from '@constants/job-info-tag-type.enum';
import JobInfoTagModel from '@models/job-info-tag/JobInfoTag';
import styles from './JobInfoTagsSection.module.scss';

export type JobInfoTagsSectionProps = {
  location?: string | null;
  occupationType?: string;
  createdDate?: string;
};

const JobInfoTagsSection: React.FC<JobInfoTagsSectionProps> = ({ location, createdDate, occupationType }) => {
  const jobInfoTags: Array<JobInfoTagModel> = [
    {
      value: location || '',
      infoType: JobInfoTagTypeEnum.LOCATION,
    },
    {
      value: createdDate || '',
      infoType: JobInfoTagTypeEnum.CREATED_AT,
    },
    {
      value: occupationType || '',
      infoType: JobInfoTagTypeEnum.OCCUPATION_TYPE,
    },
  ];

  /**
   * Gets the proper icon depending on the detail it's about
   * to render.
   * @param jobInfoTagType type of @JobInfoTagModel
   */
  const getJobInfoTag = (jobInfoTagType: JobInfoTagModel) => {
    switch (jobInfoTagType.infoType) {
      case JobInfoTagTypeEnum.LOCATION:
        return (
          location && (
            <JobInfoTag
              key="location"
              icon={<LocationIcon data-testid="location-icon" className={styles.icon} />}
              testId="location"
            >
              {jobInfoTagType.value}
            </JobInfoTag>
          )
        );

      case JobInfoTagTypeEnum.CREATED_AT:
        return (
          createdDate && (
            <JobInfoTag
              key="date"
              icon={<CalendarIcon data-testid="date-icon" className={styles.icon} />}
              testId="date"
            >
              {jobInfoTagType.value}
            </JobInfoTag>
          )
        );
      default:
        return (
          occupationType && (
            <JobInfoTag
              key="occupationType"
              icon={<UserTimeIcon data-testid="occupationType-icon" className={styles.icon} />}
              testId="occupationType"
            >
              {jobInfoTagType.value}
            </JobInfoTag>
          )
        );
    }
  };

  return <section className={styles.compWrap}>{jobInfoTags.map((jobInfoTag) => getJobInfoTag(jobInfoTag))}</section>;
};

JobInfoTagsSection.propTypes = {
  location: PropTypes.string,
  occupationType: PropTypes.string,
  createdDate: PropTypes.string,
};

JobInfoTagsSection.defaultProps = {
  location: undefined,
  occupationType: undefined,
  createdDate: undefined,
};

export default JobInfoTagsSection;
